import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function I() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [source, setSource] = useState('');
    const [gap, setGap] = useState(24);
    const POSTER_MAP: any = {
        uk: '_uk',
        de: '',
    };
    const lists: any = [
        {
            img: '/responsive/picture/power-independence/11_1',
            desc: t('secI_card1_text'),
            video: {
                de: 'https://www.youtube.com/embed/0gZTQL_qyhQ?si=n811aH-HxAn2xA_-',
                fr: '',
                eu: 'https://www.youtube.com/embed/0gZTQL_qyhQ?si=EdmbQQF8jMGZvF4C',
                uk: 'https://www.youtube.com/embed/JIfPIgwpJSg?si=kH-vkFW4dT_ZmrSB',
                it: '',
                es: '',
            },
        },
        {
            img: '/responsive/picture/power-independence/11_2',
            desc: t('secI_card2_text'),
            video: {
                de: 'https://www.youtube.com/embed/tPd7T53lzso?si=QgH-fc3KpbJJC0Ng',
                fr: '',
                eu: 'https://www.youtube.com/embed/tPd7T53lzso?si=XmfdIXdZ1PU2f_UF',
                uk: 'https://www.youtube.com/embed/VmZljmbYx4c?si=lZVejOmeyXE61utv',
                it: '',
                es: '',
            },
        },
        {
            img: '/responsive/picture/power-independence/11_3',
            desc: t('secI_card3_text'),
            video: {
                de: 'https://www.youtube.com/embed/uXE_VSP2pIQ?si=6G7QrQivKv0lw0jd',
                fr: '',
                eu: 'https://www.youtube.com/embed/uXE_VSP2pIQ?si=wlRwWk64hs8GGaYu',
                uk: 'https://www.youtube.com/embed/uXE_VSP2pIQ?si=wlRwWk64hs8GGaYu',
                it: '',
                es: '',
            },
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="power-independence-I" className={`power-independence-I ${css['power-independence-I']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secI_title')}</p>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {lists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => setSource(card?.video[locale])}>
                            <EFPicture
                                src={`${card?.img}${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                                srcPad={`${card?.img}_375${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                                srcMobile={`${card?.img}_375${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                                alt={card?.desc}
                            />
                            <YoutubePlay className="youtube-icon" />
                            <p className="card-text">{card?.desc}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
